import GeoscatterMapItem from './geoscatter-map-item';

export default GeoscatterMapItem;
export { GeoscatterMapItem };
